import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    color: rgb(0, 69, 120);
`;
